import { css } from '@linaria/core';
import { theming, baseUnits } from 'styles/utils';
export const inputStyles = "omponents__Input__Input_styles_ts-inputStyles-ia33k14";

require("./Input.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Input.styles.ts");